import { render, staticRenderFns } from "./DateIconGroup.vue?vue&type=template&id=a6ca1b46&scoped=true"
import script from "./DateIconGroup.vue?vue&type=script&lang=js"
export * from "./DateIconGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ca1b46",
  null
  
)

export default component.exports